import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IndexationType } from "../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationType";

export const RegularPaymentSteppersMap = {
    paymentsIn: "Payments in",
    adviserCharges: "Adviser charges",
    investment: "Investment selection",
    review: "Review",
    doc: "Documents / declaration",
    comfirm: "Confirmation",
};

export const productMap = {
    [SubAccountType.Sipp]: "SIPP",
    [SubAccountType.Npr]: "Aberdeen SIPP",
    [SubAccountType.JuniorSipp]: "Aberdeen JSIPP",
    [SubAccountType.StocksIsa]: "ISA Stocks & Shares",
    [SubAccountType.PersonalPortfolio]: "Personal Portfolio",
    [SubAccountType.WrapCash]: "Cash Account",
    [SubAccountType.InvestmentAccount]: "Personal Portfolio",
};

export const IndexationMap = {
    [IndexationType.AverageWeeklyEarning]: "Average weekly earning",
    [IndexationType.FixedPercentage]: "User defined percentage",
};

export const FinancialAdviceMap = {
    true: "Yes",
    false: "No",
};

export enum RegularPaymentActionType {
    Add = "add",
    Edit = "edit"
}